// extracted by mini-css-extract-plugin
module.exports = {"invitation_sidepanel":"style_invitation_sidepanel__1pmF2","invitation_content":"style_invitation_content__3hggo","link":"style_link__28nQ5","comm_text":"style_comm_text__1zB02"};